module.exports = {
  fallback: 'กรุณาแก้ปัญหาแคปต์ชา',
};
